import type { ReactNode } from 'react';
import WithLoadingErrorWrapper from '@/components/with-loading-error-wrapper';
import type { ApiErrorResponse } from '@/types/async-boundary.types';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { MobileTopBar, SideBar } from '@/components';
import { SelectOrganization } from '@/components/organization/select-organization';
import { LayoutBackground } from '@/pages';
import type { OrganizationMembership } from '@/types';

type Props = {
  show: boolean;
  loading: boolean;
  isFetching: boolean;
  error?: ApiErrorResponse;
  userName?: string;
  organizations: any[];
  onRetry: () => Promise<{ data?: unknown; error?: unknown }>;
  onPick: (tenantName: string) => void;
  onCreate: () => void;
  onSignOut: () => void;
  children: ReactNode;
  currentActiveOrganization?: OrganizationMembership;
};

export function OrganizationSelectorGate({
  show,
  loading,
  isFetching,
  error,
  userName,
  organizations,
  onRetry,
  onPick,
  onCreate,
  onSignOut,
  children,
}: Props) {
  if (!show) return <>{children}</>;

  return (
    <WithLoadingErrorWrapper
      loading={loading}
      error={error}
      isFetching={isFetching}
      onRetry={onRetry}
    >
      <SidebarProvider defaultOpen>
        <SideBar onLogout={onSignOut} userOrganizations={organizations} />

        <SidebarInset className="relative w-full min-w-0 bg-transparent rounded-none shadow-none overflow-x-hidden ">
          <MobileTopBar />
          <LayoutBackground />
          <div>
            <SelectOrganization
              userName={userName}
              data={organizations}
              onClick={onPick}
              onCreateOrganization={onCreate}
            />
          </div>
        </SidebarInset>
      </SidebarProvider>
    </WithLoadingErrorWrapper>
  );
}
